import { Endpoints } from "src/base/Endpoints";
import { HttpMethod } from "src/helpers";

export interface ISyncSession {
  id: string;
  partner_id: string;
  clinic_id: string;
  sync_session_status: string;
  csv_path: string;
  created_at: string;
  updated_at: string;
}

export interface IDataConnectRemoteDatasource {
  createSyncSession(): Promise<ISyncSession>;
  getSyncSessionStatus(syncSessionId: string): Promise<ISyncSession>;
}

export class DataConnectRemoteDatasource implements IDataConnectRemoteDatasource {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
  }

  private getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem("TOKEN");
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  }

  async createSyncSession(): Promise<ISyncSession> {
    const endpoint = Endpoints.createSyncSession;
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      method: HttpMethod.POST,
      headers: this.getAuthHeaders(),
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `同期指示の作成に失敗しました (Status: ${response.status})`
      );
    }

    const data = await response.json();
    return data;
  }

  async getSyncSessionStatus(syncSessionId: string): Promise<ISyncSession> {
    const endpoint = Endpoints.getSyncSessionStatus(syncSessionId);
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      method: HttpMethod.GET,
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `同期指示のステータス取得に失敗しました (Status: ${response.status})`
      );
    }

    const data = await response.json();
    return data;
  }
}
